import React, { useState } from "react";
import Dropzone from "react-dropzone";

import Required from "./Required";

export default function FileFieldLocal({
  help,
  disabled,
  input,
  label,
  required,
  meta: { touched, error, warning },
  stack,
  accept,
  maxSize,
  // Opt-in multi-file support. Kept off by default so existing single-file
  // usages keep behaving exactly as before.
  multiple = false,
  maxFiles = 1,
}) {
  let files = input.value || [];
  if (!Array.isArray(files)) {
    files = [];
  }

  const [isSubmitting, setSubmitting] = useState(false);
  const [limitError, setLimitError] = useState(null);

  const limit = multiple ? maxFiles : 1;

  function removeFile(fileToRemove) {
    const newFiles = files.filter((f) => f !== fileToRemove);
    setLimitError(null);
    input.onChange(newFiles);
  }

  function handleDrop(acceptedFiles) {
    if (!multiple) {
      input.onChange(acceptedFiles);
      return;
    }

    // Accumulate across drops so the user can add files one batch at a time,
    // skipping duplicates (same name + size).
    const isSame = (a, b) => a.name === b.name && a.size === b.size;
    const merged = [...files];
    acceptedFiles.forEach((file) => {
      if (!merged.some((existing) => isSame(existing, file))) {
        merged.push(file);
      }
    });

    if (merged.length > limit) {
      setLimitError(`You can upload a maximum of ${limit} files.`);
      input.onChange(merged.slice(0, limit));
      return;
    }

    setLimitError(null);
    input.onChange(merged);
  }

  return (
    <div className={`form-group ${input.name.split(".").join("_")}`}>
      <label
        htmlFor={label}
        className={`${!stack && "col-sm-3"} control-label`}
      >
        {label} {required && <Required />}
      </label>
      <div className={`${!stack && "col-sm-9"}`}>
        {files.map((file, i) => (
          <div key={i} style={{ marginBottom: 5 }}>
            <span>{file.name}</span>{" "}
            <a
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => removeFile(file)}
            >
              <i className="fa fa-times" />
            </a>
          </div>
        ))}

        {isSubmitting && (
          <div className="alert alert-info">... processing ...</div>
        )}
        {!disabled && (
          <Dropzone
            name={label}
            style={{ marginBottom: 0 }}
            className="well"
            data-cy="dropzone"
            accept={accept}
            maxSize={maxSize}
            multiple={multiple}
            onDrop={(acceptedFiles, e) => {
              handleDrop(acceptedFiles);
            }}
          >
            <div>
              Try dropping some files here, or click to select files to upload.
            </div>
          </Dropzone>
        )}
        {multiple && (
          <p className="help-text" style={{ marginTop: 5 }}>
            {files.length} of {limit} file(s) selected.
          </p>
        )}
        {limitError && (
          <div className="alert alert-warning" style={{ marginTop: 5 }}>
            {limitError}
          </div>
        )}
        {touched &&
          ((error && <div className="alert alert-danger">{error}</div>) ||
            (warning && <div className="alert alert-warning">{warning}</div>))}
        {help && <p className="help-text">{help}</p>}
      </div>
    </div>
  );
}
